import React from 'react';

/**
 * PageHero — full-width navy hero banner used at the top of every public page.
 *
 * Centers content VISUALLY in the navy box even though a fixed Navbar (~140px)
 * overlaps the top of the section. We do this with two stacked divs that share
 * the same background color: a navbar-spacer above and a balanced py-* content
 * div below. Result: content sits in the geometric centre of the visible
 * (navbar-uncovered) portion of the navy banner.
 */
const PageHero = ({
  kicker,
  title,
  subtitle,
  logoUrl,
  italicNote,
  className = '',
  contentClassName = '',
  children,
  testId,
}) => {
  return (
    <section className={`bg-brand-navy ${className}`} data-testid={testId}>
      {/* Navbar offset — same color as hero so it visually disappears behind navbar */}
      <div className="h-[72px] sm:h-[100px] lg:h-[152px]" aria-hidden />
      {/* Balanced content area */}
      <div className={`py-12 sm:py-16 md:py-24 lg:py-28 px-6 ${contentClassName}`}>
        <div className="max-w-4xl mx-auto text-center animate-fade-in-up">
          {logoUrl && (
            <img
              src={logoUrl}
              alt=""
              className="h-20 w-20 mx-auto object-contain mb-6"
              loading="eager"
            />
          )}
          {kicker && (
            <p className="text-xs uppercase tracking-ultra-wide text-brand-teal-light font-body mb-3">
              {kicker}
            </p>
          )}
          {title && (
            <h1 className="font-heading font-light text-3xl sm:text-4xl lg:text-5xl text-white uppercase tracking-ultra-wide mb-4">
              {title}
            </h1>
          )}
          {italicNote && (
            <p className="text-white/70 text-sm font-body font-light italic mb-5">
              {italicNote}
            </p>
          )}
          {(title || kicker) && <div className="w-12 h-px bg-brand-teal-light mx-auto mb-5"></div>}
          {subtitle && (
            <p className="text-white/70 text-sm font-body font-light max-w-xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
